import { Provider, Site, Submission, Debit } from 'interfaces';
import { useState, useEffect } from 'react';

interface DisableReportChipProps {
  submissions: Submission[];
  sites: Site[];
  providers: Provider[];
  debits?: Debit[];
}

export function useDisableReportChip({
  submissions,
  sites,
  providers,
  debits,
}: DisableReportChipProps) {
  const [disableChip, setDisableChip] = useState({
    siteReport: false,
    providerReport: false,
    statusReport: false,
    tariffReport: false,
    patientReport: false,
    submissionReport: false,
    tariffProviderReport: false,
    tariffDateReport: false,
    incomeProviderReport: false,
    incomeSiteReport: false,
  });

  useEffect(() => {
    setDisableChip({
      ...disableChip,
      providerReport: providers.length === 0,
      siteReport: sites.length === 0,
      submissionReport: submissions.length === 0,
      incomeProviderReport: debits?.length === 0,
      incomeSiteReport: debits?.length === 0,
    });
  }, [submissions, sites, providers, debits]);

  return disableChip;
}
